const SERVICES = [
  {
    icon: (
      <svg viewBox="0 0 24 24">
        <rect x="3" y="3" width="18" height="18" rx="2"/>
        <path d="M3 9h18M9 21V9"/>
      </svg>
    ),
    title: 'Weby',
    desc: 'Moderné, rýchle a konverzné weby na React alebo WordPress. Od landing page po firemný web s CMS – dodáme do 7 dní.',
    tags: ['React', 'WordPress', 'Next.js', 'TypeScript'],
  },
  {
    icon: (
      <svg viewBox="0 0 24 24">
        <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>
        <line x1="3" y1="6" x2="21" y2="6"/>
        <path d="M16 10a4 4 0 01-8 0"/>
      </svg>
    ),
    title: 'E-shopy',
    desc: 'WooCommerce a custom e-shopy s vlastným dizajnom, platobnou bránou a správou produktov. Predávajte online od prvého dňa.',
    tags: ['WooCommerce', 'Stripe', 'Custom PHP', 'PayPal'],
  },
  {
    icon: (
      <svg viewBox="0 0 24 24">
        <path d="M22 12h-4l-3 9L9 3l-3 9H2"/>
      </svg>
    ),
    title: 'Marketing',
    desc: 'Google Ads, Meta Ads, SEO a e-mail marketing, ktoré prinášajú skutočných zákazníkov – nie len kliky. Dáta-driven prístup.',
    tags: ['Google Ads', 'Meta Ads', 'SEO', 'Analytics'],
  },
  {
    icon: (
      <svg viewBox="0 0 24 24">
        <path d="M21 2H3v16h5v4l4-4h4l5-5V2z"/>
        <path d="M10 8v4M14 8v4"/>
      </svg>
    ),
    title: 'Sociálne siete',
    desc: 'Pravidelný obsah, stratégia a správa Instagram, Facebook, LinkedIn. Budujeme komunitu, ktorá kupuje a odporúča.',
    tags: ['Instagram', 'Facebook', 'LinkedIn', 'Content'],
  },
  {
    icon: (
      <svg viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="3"/>
        <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/>
      </svg>
    ),
    title: 'Správa systémov',
    desc: 'Pravidelné aktualizácie, zálohy, uptime monitoring a technická podpora. Váš web vždy rýchly, bezpečný a bez výpadkov.',
    tags: ['Hosting', 'SSL', 'Updates', 'Monitoring'],
  },
  {
    icon: (
      <svg viewBox="0 0 24 24">
        <ellipse cx="12" cy="5" rx="9" ry="3"/>
        <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"/>
        <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"/>
      </svg>
    ),
    title: 'Interné systémy & CRM',
    desc: 'Vlastný CRM, správa klientov, projektov a mailingov. Jednoduché interné systémy na mieru cez moderné nástroje.',
    tags: ['CRM', 'Klienti', 'Projekty', 'Mailing'],
  },
];

export default function Services() {
  return (
    <section id="sluzby" aria-labelledby="sluzby-heading">
      <div className="container">
        <div className="section-header">
          <span className="section-tag fade-up">Služby</span>
          <h2 id="sluzby-heading" className="section-h2 fade-up delay-1">
            Čo robíme <span className="grad">najlepšie</span>
          </h2>
          <p className="section-sub fade-up delay-2">
            Komplexná digitálna starostlivosť o vašu firmu. Žiadne half-measures.
          </p>
        </div>
        <div className="services-grid">
          {SERVICES.map((s, i) => (
            <div key={s.title} className={`service-card fade-up${i > 0 ? ` delay-${Math.min(i, 4)}` : ''}`}>
              <div className="service-icon" aria-hidden="true">{s.icon}</div>
              <div>
                <h3 className="service-title">{s.title}</h3>
                <p className="service-desc">{s.desc}</p>
              </div>
              <div className="service-tags">
                {s.tags.map((t) => <span key={t} className="tag">{t}</span>)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
